import { Tween, Easing } from '@tweenjs/tween.js';
import AnimationClip from '../AnimationClip';
import ElementComponent from '../../../Component/UI/Element';
import ThreeStarItem from '../../../Prototype/UI/Popup/ThreeStarItem';

export class ThreeStarRewardWiggle extends AnimationClip {
    public *execute(
        gameObject: ThreeStarItem,
        meta?: any
    ): IterableIterator<number> {
        const element = gameObject.getComponent(ElementComponent);

        if (element.layout.angle === undefined) {
            element.layout.angle = 0;
        }

        const delay: number = 75;
        const degree: number = 5;
        const rot1 = element.layout.angle + degree;
        const rot2 = element.layout.angle - degree;
        const rotT = element.layout.angle;

        const tween: Tween = this.getTween(element.layout);
        tween.easing(Easing.Quadratic.InOut);

        yield* this.tweenTo(tween, rot2, delay);
        yield* this.tweenTo(tween, rot1, delay);
        yield* this.tweenTo(tween, rot2, delay);
        yield* this.tweenTo(tween, rot1, delay);
        yield* this.tweenTo(tween, rotT, delay);

        gameObject.texture = meta.cacheKey;
    }

    private *tweenTo(
        tween: Tween,
        rotation: number,
        delay: number
    ): IterableIterator<number> {
        tween.to({ angle: rotation }, delay);
        yield* this.startTween(tween);
    }
}
